export default __webpack_public_path__ + "static/media/formas-digitales-banner-precios.f1a1f963.png";